<template>
	<div>
		<FormAula
			:aula="aulaEdit"
			:cursoId="cursoId"
			:materias="materias"
			:typeForm="typeForm"
			@changeTypeForm="changeTypeForm"
			v-if="showFormAula"
		></FormAula>
		<FormMateria
			:materia="materiaEdit"
			:cursoId="cursoId"
			:typeForm="typeForm"
			@changeTypeForm="changeTypeForm"
			v-if="showFormMateria"
		></FormMateria>

		<v-row>
			<v-col cols="12" v-if="XMLHttpRequest">
				<v-btn
					:to="{ name: 'Cursos' }"
					color="success"
					class="mr-2 btn-square float-left"
					title="Voltar"
				>
					<v-icon small>fal fa-arrow-left</v-icon>
				</v-btn>
				<v-speed-dial
					dark
					direction="right"
					transition="scale-transition"
					class="float-left"
				>
					<template v-slot:activator>
						<v-btn color="success" dark class="btn-square">
							<v-icon small>fal fa-plus</v-icon>
						</v-btn>
					</template>
					<v-btn @click="formMateria(0, null)" color="success" small>
						Matéria
					</v-btn>
					<v-btn @click="formAula()" color="success" small>
						Aula
					</v-btn>
				</v-speed-dial>

				<v-speed-dial
					dark
					direction="left"
					transition="scale-transition"
					class="float-right"
				>
					<template v-slot:activator>
						<v-btn :color="(archiveAula||archiveMateria)?'orange lighten-1':'grey'" dark class="btn-square">
							<v-icon small>fal fa-archive</v-icon>
						</v-btn>
					</template>
					<v-btn
						@click="archiveMateria = !archiveMateria"
						:color="(archiveMateria)?'orange lighten-1':'grey'"
						title="Arquivo de matérias"
						dark
						small
					>
						Matéria
					</v-btn>
					<v-btn
						@click="archiveAula = !archiveAula"
						:color="(archiveAula)?'orange lighten-1':'grey'"
						title="Arquivo de aulas"
						dark
						small
					>
						Aula
					</v-btn>
				</v-speed-dial>
			</v-col>
		</v-row>

		<v-expansion-panels v-if="materias" focusable class="mt-2">
			<v-expansion-panel
				v-for="materia in materias"
				:key="materia.id"
				class="grey lighten-5"
			>
				<v-expansion-panel-header>
					<div :class="colorMateria(materia.mostrar, archiveMateria)">
						<h3>
							<v-icon small left>fas fa-books</v-icon>
							{{ materia.nome }}
						</h3>
					</div>
				</v-expansion-panel-header>
				<v-expansion-panel-content>
					<!-- Aula.vue -->
					<Aula
						:aulas="filterAulas(materia.id)"
						:materias="materias"
						:archiveAula="archiveAula"
					></Aula>

					<v-row class="mt-4">
						<v-spacer></v-spacer>
						<v-btn
							@click="ordenationMateria('up', materia)"
							class="mr-1 btn-square"
							title="ordenar"
						>
							<v-icon>fal fa-angle-up</v-icon>
						</v-btn>
						<v-btn
							@click="ordenationMateria('down', materia)"
							class="mr-1 btn-square"
							title="ordenar"
						>
							<v-icon>fal fa-angle-down</v-icon>
						</v-btn>
						<v-btn
							:color="
								materia.mostrar == true ? 'green darken-1' : 'grey darken-1'
							"
							class="mr-3 btn-square"
							title="Editar matéria"
							@click="formMateria(1, materia)"
							dark
							><v-icon small>fal fa-pen-alt</v-icon></v-btn
						>
					</v-row>
				</v-expansion-panel-content>
			</v-expansion-panel>
		</v-expansion-panels>

		<v-alert
			color="blue-grey darken-1"
			dark
			border="right"
			icon="fas fa-empty-set"
			v-else
		>
			Sem dados cadastrados
		</v-alert>
	</div>
</template>

<script>
import { mapState } from 'vuex'

import FormAula from '@/components/admin/FormAula'
import FormMateria from '@/components/admin/FormMateria'
import Aula from '@/components/admin/Aula'

export default {
	components: {
		Aula,
		FormAula,
		FormMateria,
	},
	data() {
		return {
			server: 'aula',
			showFormAula: false,
			showFormMateria: false,
			materias: [],
			aulas: [],
			archiveMateria: false,
			archiveAula: false,
			aulaEdit: {},
			materiaEdit: {},
			cursoId: null,
		}
	},
	beforeRouteUpdate(to, from, next) {
		this.cursoId = to.params.id
		next()
	},
	computed: {
		...mapState(['user', 'XMLHttpRequest', 'searchAula']),
	},
	created() {
		this.cursoId = this.$route.params.id
	},
	watch: {
		cursoId() {
			this.getData()
		},
		searchAula(val) {
			if (val === true) {
				this.getData()
			}
		},
		archiveMateria() {
			this.getData()
		},
		archiveAula() {
			this.getData()
		},
	},
	methods: {
		filterAulas(materiaId) {
			let aulasTemp = false
			if (this.aulas != undefined) {
				aulasTemp = this.aulas.filter((a) => a.materia_id == materiaId)
			}
			if (aulasTemp.length == 0) {
				aulasTemp = false
			}
			return aulasTemp
		},
		getData() {
			let formData = new FormData()
			formData.append('menu', this.server)
			formData.append('function', 'get_' + this.server)
			formData.append('user_id', this.user.id)
			formData.append('curso_id', this.cursoId)
			formData.append('archive_materia', this.archiveMateria)
			formData.append('archive_aula', this.archiveAula)
			let vd = this

			this.$axiosPost
				.post('functions.php', formData, {
					headers: { Authorization: this.user.token },
				})
				.then(function(response) {
					vd.$store.dispatch('searchAula', { value: false })
					if (response.data.error === 0) {
						vd.aulas = response.data.aulas
						vd.materias = response.data.materias
					} else {
						vd.$store.dispatch('errorServer', {
							data: response.data,
							destino: vd.$route.path,
						})
					}
				})
				.catch(function(response) {
					console.log('ERRO!! ' + response)
				})
		},
		colorMateria(active, archive) {
			if (archive == true) {
				return 'orange--text'
			} else if (active == true) {
				return 'green--text'
			} else {
				return 'grey--text text--accent-4'
			}
		},
		formAula() {
			this.typeForm = 0
			this.showFormAula = true
			setTimeout(() => {
				this.$store.dispatch('dialogAula', { value: true })
			}, 300)
		},
		formMateria(type, materia) {
			this.typeForm = type
			if (type === 0) {
				this.materiaEdit = {}
			} else {
				this.materiaEdit = Object.assign({}, materia)
			}
			this.showFormMateria = true
			setTimeout(() => {
				this.$store.dispatch('dialogMateria', { value: true })
			}, 300)
		},
		changeTypeForm(value) {
			this.typeForm = value.typeForm
			if (value.hideForm == 'aula') {
				this.showFormAula = false
			}
			if (value.hideForm == 'materia') {
				this.showFormMateria = false
			}
		},
		ordenationMateria(type, materia) {
			let formData = new FormData()
			formData.append('menu', 'materia')
			formData.append('function', 'order_materia')
			formData.append('user_id', this.user.id)
			formData.append('curso_id', materia.curso_id)
			formData.append('id', materia.id)
			formData.append('ordenation', materia.ordenation)
			formData.append('archive_materia', this.archiveMateria)
			formData.append('type', type)
			let vd = this
			this.$axiosPost
				.post('functions.php', formData, {
					headers: { Authorization: this.user.token },
				})
				.then(function(response) {
					if (response.data.error === 0) {
						vd.$store.dispatch('alert', {
							alertMessage: response.data.alertMessage,
							alertType: 0,
						})
						vd.$store.dispatch('searchAula', { value: true })
					} else {
						vd.$store.dispatch('errorServer', {
							data: response.data,
							destino: vd.$route.path,
						})
					}
				})
				.catch(function(response) {
					console.log('ERROR!! ' + response)
				})
		},
	},
}
</script>
<style lang="css">
.v-expansion-panel-content__wrap {
	padding: 0 10px 10px !important;
}
.v-speed-dial--direction-left .v-speed-dial__list, .v-speed-dial--direction-right .v-speed-dial__list{
	padding: 0;
}
</style>
